import { CommonModule as AngularCommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
// import { MomentModule } from 'ngx-moment';
// Dynamic form Services
import { DynamicFormV3UtilsService } from './services/dynamic-form-v3-utils.service';
import { DynamicFormQuestionControlServiceV3 } from './services/question-control.service';
import { DynamicFormQuestionParserServiceV3 } from './services/question-parser.service';
// Dynamic form components
import { DynamicFormControlsComponentV3 } from './components/dynamic-form-controls/dynamic-form-controls.component';
import { DynamicFormProgressBarComponentV3 } from './components/dynamic-form-progress-bar/dynamic-form-progress-bar.component';
import { DynamicFormQuestionComponentV3 } from './components/dynamic-form-question/dynamic-form-question.component';
import { DynamicFormComponentV3 } from './components/dynamic-form/dynamic-form.component';
// Dynamic form input label
import { QuestionTitleV3 } from './components/question-title/question-title.component';
// Dynamic form input fields
import { InputTextComponentV3 } from './components/questions/input-text/input-text.component';
import { FieldNestedGroupComponentV3 } from './components/questions/field-nested-group/field-nested-group.component';
import { FieldsBlockComponentV3 } from './components/questions/fields-block/fields-block.component';
import { InputCheckboxComponentV3 } from './components/questions/input-checkbox/input-checkbox.component';
import { InputDatetimeComponentV3 } from './components/questions/input-datetime/input-datetime.component';
import { InputDescriptionComponentV3 } from './components/questions/input-description/input-description.component';
import { InputDropdownComponentV3 } from './components/questions/input-dropdown/input-dropdown.component';
import { InputEq5VerticalSliderV3 } from './components/questions/input-eq5-vertical-slider/input-eq5-vertical-slider.component';
import { InputFileComponentV3 } from './components/questions/input-file/input-file.component';
import { InputHiddenComponentV3 } from './components/questions/input-hidden/input-hidden.component';
import { InputHtmlComponentV3 } from './components/questions/input-html/input-html.component';
import { InputImageComponentV3 } from './components/questions/input-image/input-image.component';
import { InputMultiDropdownComponentV3 } from './components/questions/input-multiDropdown/input-multiDropdown.component';
import { InputNumberRangeV3Component } from './components/questions/input-number-range/input-number-range.component';
import { InputPhotoComponentV3 } from './components/questions/input-photo/input-photo.component';
import { InputRadioComponentV3 } from './components/questions/input-radio/input-radio.component';
import { InputRangeComponentV3 } from './components/questions/input-range/input-range.component';
import { InputSemanticComponentV3 } from './components/questions/input-semantic/input-semantic.component';
import { InputSocialSecurityComponentV3 } from './components/questions/input-social-security/input-social-security.component';
import { InputTextAreaComponentV3 } from './components/questions/input-textarea/input-textarea.component';
import { InputToggleComponentV3 } from './components/questions/input-toggle/input-toggle.component';
import { InputSignaturePadComponentV3 } from './components/questions/input-signature-pad/input-signature-pad.component';
import { SignatureModalComponent } from './components/signature-modal/signature-modal.component';
import { InputVideoComponentV3 } from './components/questions/input-video/input-video.component';
import { BepatientVideoComponent } from '../bepatient-video/bepatient-video.component';
import { InputButtonComponentV3 } from './components/questions/input-button/input-button.component';
import { BepatientButtonComponent } from '../bepatient-button/bepatient-button.component';
import { InputTimeComponentV3 } from './components/questions/input-time/input-time.component';

@NgModule({
  imports: [
    IonicModule,
    // MomentModule,
    AngularCommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild()
  ],
  providers: [
    DynamicFormV3UtilsService,
    DynamicFormQuestionParserServiceV3,
    DynamicFormQuestionControlServiceV3,
    Store
  ],
  declarations: [
    DynamicFormComponentV3,
    DynamicFormQuestionComponentV3,
    DynamicFormControlsComponentV3,
    DynamicFormProgressBarComponentV3,
    QuestionTitleV3,
    InputTextComponentV3,
    FieldNestedGroupComponentV3,
    FieldsBlockComponentV3,
    InputCheckboxComponentV3,
    InputDatetimeComponentV3,
    InputDescriptionComponentV3,
    InputDropdownComponentV3,
    InputEq5VerticalSliderV3,
    InputFileComponentV3,
    InputHiddenComponentV3,
    InputHtmlComponentV3,
    InputImageComponentV3,
    InputMultiDropdownComponentV3,
    InputNumberRangeV3Component,
    InputPhotoComponentV3,
    InputRadioComponentV3,
    InputRangeComponentV3,
    InputSemanticComponentV3,
    InputSocialSecurityComponentV3,
    InputTextAreaComponentV3,
    InputToggleComponentV3,
    InputSignaturePadComponentV3,
    SignatureModalComponent,
    InputVideoComponentV3,
    BepatientVideoComponent,
    InputButtonComponentV3,
    BepatientButtonComponent,
    InputTimeComponentV3
  ],
  exports: [
    DynamicFormComponentV3,
    DynamicFormQuestionComponentV3,
    DynamicFormControlsComponentV3,
    DynamicFormProgressBarComponentV3,
    QuestionTitleV3,
    InputTextComponentV3,
    FieldNestedGroupComponentV3,
    FieldsBlockComponentV3,
    InputCheckboxComponentV3,
    InputDatetimeComponentV3,
    InputDescriptionComponentV3,
    InputDropdownComponentV3,
    InputEq5VerticalSliderV3,
    InputFileComponentV3,
    InputHiddenComponentV3,
    InputHtmlComponentV3,
    InputImageComponentV3,
    InputMultiDropdownComponentV3,
    InputNumberRangeV3Component,
    InputPhotoComponentV3,
    InputRadioComponentV3,
    InputRangeComponentV3,
    InputSemanticComponentV3,
    InputSocialSecurityComponentV3,
    InputTextAreaComponentV3,
    InputToggleComponentV3,
    InputSignaturePadComponentV3,
    SignatureModalComponent,
    InputVideoComponentV3,
    BepatientVideoComponent,
    InputButtonComponentV3
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DynamicFormV3Module {}
